import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { ClientFacadeService } from '../../services/client-facade.service';
import { ModalService } from '../../../../shared/services/modal.service';
import { Client } from '../../models/client';

@Component({
  selector: 'app-confirm-delete-client-modal',
  standalone: true,
  imports: [CommonModule, ButtonModule, ModalComponent],
  templateUrl: './confirm-delete-client-modal.component.html',
  styleUrl: './confirm-delete-client-modal.component.css',
})
export class ConfirmDeleteClientModalComponent implements OnInit {
  private readonly modalService = inject(ModalService);

  @Input() data?: { client: Client; onConfirm: (client: Client) => void };
  client?: Client;

  ngOnInit() {
    this.client = this.data?.client;
  }

  deleteClient() {
    if (this.client && this.data?.onConfirm) {
      this.data.onConfirm(this.client);
      this.modalService.close();
    }
  }
}
